import React, { Component } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { notification, message, Spin } from 'antd';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default class AreaResp extends Component {
  
  state = {
    labels:[],
    values: [],
    loading: false
  }

  componentDidMount(){

    const { unidad_medica_user, periodo, backend } = this.props;

    fetch(`${backend}/arearespV2/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            labels: data.data.labels,
            values: data.data.values,
            loading:true
          });
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener consultas por área de responsabilidad",
          });
          message.destroy()
      });
  }

  render() {

    const { labels, values, loading } = this.state;

    const options = {
      responsive: true,
      maintainAspectRatio: false ,
      plugins: [ChartDataLabels],
      plugins: {
        legend: {
          position: 'bottom',
        },
        
        title: {
          display: true,
          text: 'Por área de responsabilidad',
          font:{
            size:'28'
          }
        },
        datalabels:{
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: '15'
          },
          // formatter: (value) => {
          //   return value + '%'
          // }

          formatter: (value, context) => {
            // return context.dataIndex 
            let sum = 0;
            let dataArr = context.chart.data.datasets[0].data;
            dataArr.map(data => {
               sum += data;
            });
            // let percentage = (value*100 / sum).toFixed(2)+"%";
            // return context.chart.data.labels[context.dataIndex] + value + '\n' + percentage
            return value
          }
        }
      },
    }  

    const data = {
      // labels: ['Mujer', 'Hombre', 'Otro'],
      labels: labels,

      datasets: [
        {
          // label: '# of Votes',
          // data: [8,10, 1],
          data: values,
          backgroundColor: [
            'rgba(64, 136, 254, 1)',
            'rgb(113, 242, 195)',
            'rgba(247, 81, 88, 1)',
            'rgba(237, 21, 211, 1)',
            'rgb(12, 207, 242, 1)',
            'rgb(214, 244, 14, 1)',
            'rgb(247, 185, 14, 1)'
          ],
          borderColor: [
            'rgba(64, 136, 254, 1)',
            'rgb(113, 242, 195)',
            'rgba(247, 81, 88, 1)',
            'rgba(237, 21, 211, 1)',
            'rgb(12, 207, 242, 1)',
            'rgb(214, 244, 14, 1)',
            'rgb(247, 185, 14, 1)'
          ],
          borderWidth: 1,
        },
      ],
    };

    return (
      loading ?
        <Pie 
          width={290}
          height={190}
          data={data} 
          options={options} 
          plugins={'[ChartDataLabels]'}
        />
        : <Spin size="small" />

    );
  }
}